import { Component, Input, OnInit } from '@angular/core';
import { Duration } from 'luxon';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface MbrUserRegistrationTimeoutDialogData {
  onClose: () => Promise<void>;
}

@Component({
  selector: 'app-mbr-user-registration-timeout',
  templateUrl:
    './mbr-user-registration-timeout.component.html',
})
export class MbrUserRegistrationTimeoutComponent
  implements OnInit
{
  @Input() data!: MbrUserRegistrationTimeoutDialogData;

  constructor(
    public bsModalRef: BsModalRef<MbrUserRegistrationTimeoutComponent>
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.bsModalRef.hide();
      this.data.onClose();
    }, Duration.fromObject({ minute: 1 }).toMillis());
  }
}
